import { memo } from 'react';
import { ForgotIdConfirmTemplate } from 'components/templates/ForgotIdConfirmTemplate';

type Props = {};

export const ForgotIdConfirmPage = memo((_props: Props) => {
	return <ForgotIdConfirmTemplate />;
});
